module.exports = "<svg id=\"9c0b3b67-2d34-4c39-8659-ef8bd57e2a76\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 49.68\"><title>Pin</title><path d=\"M24.4.32a16.63,16.63,0,0,0-17,16.9,19.78,19.78,0,0,0,1.4,6.32C13.56,33.84,17.28,39.69,24.43,50c7.25-10.79,11.27-16.26,16-26.46a19.41,19.41,0,0,0,1-6.32A16.69,16.69,0,0,0,24.4.32Zm-.12,27.36A10.33,10.33,0,1,1,34.51,17.36,10.28,10.28,0,0,1,24.28,27.69Z\" transform=\"translate(-7.42 -0.32)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Pin.svg
// module id = 520
// module chunks = 1